import { MbAnagraficaUm } from "../mb_anagrafiche/mb_tables/mb_anagrafica_um";
import { MbMessage } from "../mb_components/mb_message";

const MbValidatorUm = ({callbackFromValidator}) => {

    return (
        <>
            <MbMessage title="Aliquota" helper="Selezionare un'aliquota" open isFullscreen>
                <div style={{paddingLeft: "30px", paddingRight: "30px"}}>
                    <MbAnagraficaUm isValidator callbackFromValidator={(item) => {
                        callbackFromValidator(item);
                    }}/>
                </div>
            </MbMessage>
        </>
    );
};

export {
    MbValidatorUm
}